<template>
  <div class="side_bar">
    <div class="inner">
      <ul class="list">
        <li class="heading">Overview</li>
        <li class=""><router-link :to="{name: 'getting-started' }">Getting Started</router-link></li>
        <li class=""><router-link :to="{name: 'authentication' }">Authentication</router-link></li>
      </ul>

      <ul class="list">
        <li class="heading">API Methods</li>
        <li class=""><router-link :to="{name: 'users' }">Users</router-link></li>
        <li class=""><router-link :to="{name: 'brands' }">Brands</router-link></li>
        <li class=""><router-link :to="{name: 'campaigns' }">Campaigns</router-link></li>
        <li class=""><router-link :to="{name: 'links' }">Links</router-link></li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SideBar',
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SideBar.vue